import { createSlice } from "@reduxjs/toolkit";
import { getStartOfDayForPrisma } from "../../helpers";

const initialState = {
  scheduleEvents: {
    data: [],
    isLoading: false,
    message: null,
  },
  filters: {
    date: getStartOfDayForPrisma(),
  },
};

const patientSurgeryStatesByDelete = [
  "ASSESSMENT_MADE",
  "ASSESSMENT_MADE_RESCHEDULE",
  "FINISHED",
  "ASSESSMENT_NO_SHOW",
  "QUIZ_SATISFACTION_ANSWERED",
];

export const dailyAssessmentSlice = createSlice({
  name: "dailyAssessment",
  initialState,
  reducers: {
    loadingScheduleEvents: (state) => {
      state.scheduleEvents.isLoading = true;
      state.scheduleEvents.message = null;
    },
    loadedScheduleEvents: (state, { payload }) => {
      state.scheduleEvents.data = payload.scheduleEvents;
      state.scheduleEvents.isLoading = false;
      state.scheduleEvents.message = {
        type: "success",
        text: payload.message,
      };
    },
    failedScheduleEvents: (state, { payload }) => {
      state.scheduleEvents.isLoading = false;
      state.scheduleEvents.data = [];
      state.scheduleEvents.message = {
        type: "error",
        text: payload,
      };
    },
    deleteScheduleEvent: (state, { payload }) => {
      const { id, patientSurgery } = payload;

      if (!patientSurgeryStatesByDelete.includes(patientSurgery.state)) return;

      state.scheduleEvents.data = state.scheduleEvents.data.filter(
        (scheduleEvent) => scheduleEvent.id !== id
      );
    },
    changeFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadingScheduleEvents,
  loadedScheduleEvents,
  failedScheduleEvents,
  deleteScheduleEvent,
  changeFilters,
} = dailyAssessmentSlice.actions;
